import anime from 'animejs';
import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { InjectedApiProps, withApi } from 'src/_context/Api';
import { InjectedAppScrollerProps, withAppScroller } from 'src/_context/AppScroller';
import closeIcon from 'src/assets/icons/Close.svg';
import responsive from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { directions } from 'src/constants/stylesheet';
import Image from './Image';
export type BackgroundProps =
    {
        loading: boolean;
        loaded: () => void;
    };

const styles = {
    container: {
        height: '100%'
    },
    background: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        '& img': {
            height: '100%',
            width: '100%',
            objectFit: 'cover'
        }
    },
    backgroundMask: {
        position: 'fixed',
        ...stylesheet.MarginGutter(-1, directions.all),
        background: 'white',
        pointerEvents: 'none',
        opacity: 1,
        transition: 'opacity 0.7s ease-out'
    },
    backgroundMaskPosition: {
        ...stylesheet.PostionGutter(1, directions.all),
    },
    legendOuter: {
        position: 'fixed',
        width: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        ...stylesheet.PostionGutter(1,directions.bottom ),
        opacity: 0,
        transition: 'opacity 0.7s ease-out',

        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',

        '& p a': {
            display: 'inline-block',
            borderBottom: '1px solid black',
            ...stylesheet.Link(false, 'center'),

            '&:hover': {
                borderColor: 'transparent'
            },
        },

        [responsive.Tablet]: {
            paddingLeft: spacing.Gutter.Mobile,
            paddingRight: spacing.Gutter.Mobile,
        },
    },
    legend: {
        ...stylesheet.Background_Caption,
        background: 'white',
        opacity: 0,
        transition: 'opacity 0.3s ease-out',
        margin: '0 auto',

        [responsive.Mobile]: {
            maxWidth: '90%',
            fontSize: '.75rem',
        },

        [responsive.AfterMobile]: {
            maxWidth: 820,
        },
    },
    legendPadding: {
        ...stylesheet.PaddingGutter(1, directions.all)
    },
    legendPaddingBootom: {
        ...stylesheet.PaddingGutter(2, directions.bottom),

        [responsive.BeforeTablet]: {
            paddingBottom: spacing.Gutter.Mobile * 2.5,
        },
        [responsive.AfterTablet]: {
            paddingBottom: spacing.Gutter.Desktop * 1.5,
        },
    },
    legendIcon: {
        position: 'absolute',
        bottom: 10,
        width: 30,
        height: 30,
        background: 'white',
        padding: 8,
        borderRadius: '100%',
        transform: 'rotate(45deg)',
        transition: 'all 0.3s ease-in-out',
        cursor: 'pointer'
    },
    legendOpened: {
        '& $legend': {
            opacity: 1
        },
        '& $legendIcon': {
            transform: 'rotate(0)'
        }
    },
    loaded: {
        '& $header': {
            transform: 'translate3d(0, 0, 0)'
        },
        '& $legendOuter': {
            opacity: 1
        },
        '& $backgroundMask': {
            opacity: 0
        }
    },
};

type Props =
    BackgroundProps &
    InjectedApiProps &
    StyledComponentProps<keyof typeof styles> &
    InjectedAppScrollerProps;

type State = {
    legendOpened: boolean
};

class Footer extends React.Component<Props, State> {
    public readonly state: State = {
        legendOpened: true
    };

    constructor(props: Props) {
        super(props);
        this._onBackgroundLoad = this._onBackgroundLoad.bind(this);
        this._toggleLegend = this._toggleLegend.bind(this);
    }

    render() {
        const { children, loading, classes, apiCtx: { app } } = this.props;
        const { legendOpened } = this.state;

        return (
            <div className={classNames(classes!.container, !loading && classes!.loaded)}>
                <div className={classNames(classes!.background)} >
                    {app &&
                        <Image
                            pictureRef={app.Config.BackgroundImage}
                            sizes="(min-width: 320px) 100vw"
                            onLoad={this._onBackgroundLoad}
                            onError={this._onBackgroundLoad}
                            onAbort={this._onBackgroundLoad}
                        />
                    }
                </div>
                <div className={classNames(classes!.backgroundMask, classes!.backgroundMaskPosition)} />
                {app &&
                    <div className={classNames(classes!.legendOuter, legendOpened && classes!.legendOpened)} >
                        <div 
                            className={
                                classNames(classes!.legend, classes!.legendPadding, classes!.legendPaddingBootom)
                            } 
                            dangerouslySetInnerHTML={{__html: app.Config.Legend}} 
                        />
                        <img
                            src={closeIcon}
                            alt="close icon"
                            className={classes!.legendIcon}
                            onClick={this._toggleLegend}
                        />
                    </div>
                }
                {children}
            </div>
        );
    }

    private _onBackgroundLoad() {
        const { classes, loaded } = this.props;
        anime({
            targets: `.${classes!.backgroundMask}`,
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            marginBottom: 0,
            duration: 500,
            easing: 'linear',
            complete: loaded
        });
    }

    private _toggleLegend() {
        this.setState(({ legendOpened }) => ({ legendOpened: !legendOpened }))
    }
}

export default withStyles(styles)(withAppScroller(withApi(Footer)));


// WEBPACK FOOTER //
// ./src/components/Background.tsx